'use strict';

/**
 * Инит магнифика, тип inline
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#inline-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import Preloader from '../Preloader';

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector=".js-mfp-inline"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init (selector, $context, userConfig) {
	let $elements = (selector && selector.jquery) ? selector : $(selector, $context);
	$elements.each((i, el) => {
		let $element = $(el);
		let config = $.extend(true, {
			type: 'inline',
			closeBtnInside: false,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in',
			closeMarkup: '<button class="mfp-close" id="custom-close-btn"></button>'
		}, userConfig);

		$element.magnificPopup(config);
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector=".js-mfp-inline"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpInline (selector = '.js-mfp-inline', $context = $('body'), userConfig = {}) {
	function load (event) {
		event.preventDefault();
		$context.off('click', selector, load);

		let $element = $(this);
		let preloader = new Preloader($element);
		preloader.show();

		import(
			/* webpackChunkName: "magnific-popup" */
			'./mfp'
		).then(() => {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.magnificPopup('open');
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export default mfpInline;



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/mfp/mfp-inline.js